/*
 * Copyright (c) CIRROM 2025.
 */

import styled from "@emotion/styled";
import { ListItemButton } from "@mui/material";
import { MiraTheme } from "../../theme/theme";

export const Heading = styled(ListItemButton)<{ theme?: MiraTheme }>`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding: 0 ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }
`;
export const Wrapper = styled.div`
  width: 300px;
  overflow-x: hidden;
`;
